import { find, isArray, isEmpty, map } from "lodash";

type MentionsArgs = {
  mentions: {
    id: string;
    displayName?: string;
    display_name?: string;
    url: string;
    images:
      | { [key: string]: string }
      | { url: string; width: number; height: number }[];
  }[];
};

export default function Mentions({ mentions }: MentionsArgs) {
  return (
    <div className="activity-people attachments">
      <ul className="people-container activity-section empty:hidden border-0!">
        {map(mentions, (m) => (
          <li key={m.id} className="flex flex-col gap-2 mb-2 last:mb-0">
            <a
              className="flex flex-1 gap-2 member-link items-center"
              href={m.url}
              title={m.displayName}
            >
              {!isEmpty(m.images) && (
                <img
                  className="w-7 h-7"
                  src={
                    isArray(m.images)
                      ? find(m.images, { width: 80, height: 80 })?.url
                      : m.images["40x40@2"]
                  }
                  alt={m.displayName || m.display_name}
                />
              )}
              {m.displayName || m.display_name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
